import { optionTitle_premium_subscription } from './SubscriptionOption.locstring.json';
import { LazyOption, createLazyOption } from 'owa-options-core';
import { LazyModule } from 'owa-bundling';
import { isFeatureEnabled } from 'owa-feature-flags';
import { getUserConfiguration } from 'owa-session-store';
var lazyFullModule = new LazyModule(() => import('./lazyFullOption'));
let SubscriptionOption: LazyOption = createLazyOption(
    {
        key: 'subscription',
        titleStringKey: optionTitle_premium_subscription,
        searchTermsStringKey: optionTitle_premium_subscription,
        isHidden: () =>
            isFeatureEnabled('auth-PremiumDashboardApril') ||
            !isFeatureEnabled('auth-PremiumDashboard') ||
            !getUserConfiguration().SessionSettings.IsPremiumConsumerMailbox,
    },
    lazyFullModule,
    m => m.default
);
let SubscriptionOptionApril: LazyOption = createLazyOption(
    {
        key: 'subscription_',
        titleStringKey: optionTitle_premium_subscription,
        searchTermsStringKey: optionTitle_premium_subscription,
        isHidden: () =>
            !isFeatureEnabled('auth-PremiumDashboardApril') ||
            !getUserConfiguration().SessionSettings.IsPremiumConsumerMailbox,
    },
    lazyFullModule,
    m => m.default
);
export default SubscriptionOption;
export { SubscriptionOptionApril };
